import { render, staticRenderFns } from "./RoomDamageCard.vue?vue&type=template&id=47e23505&scoped=true"
import script from "./RoomDamageCard.vue?vue&type=script&lang=ts"
export * from "./RoomDamageCard.vue?vue&type=script&lang=ts"
import style0 from "./RoomDamageCard.vue?vue&type=style&index=0&id=47e23505&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e23505",
  null
  
)

export default component.exports